/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Not_AvailableInputs */

const en_read_along_not_available = /** @type {(inputs: Read_Along_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const es_read_along_not_available = /** @type {(inputs: Read_Along_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Read_Along_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_not_available = /** @type {((inputs?: Read_Along_Not_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Not_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_not_available(inputs)
	return en_read_along_not_available(inputs)
});